import { render, staticRenderFns } from "./joinDialog.vue?vue&type=template&id=18aab88e&scoped=true"
import script from "./joinDialog.vue?vue&type=script&lang=js"
export * from "./joinDialog.vue?vue&type=script&lang=js"
import style0 from "./joinDialog.vue?vue&type=style&index=0&id=18aab88e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aab88e",
  null
  
)

export default component.exports